import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CCardBody } from '@coreui/react';
import Amenities from './Amenities/V2/Amenities';
import Unit from './Unit/Unit';
import {
  getBuilding,
  getBuildingSuites,
  getOrgBuildingSuites,
  resetSuitesInBuilding,
  showGlobalBuildingsDropdown
} from '../../../redux/actions/building';
import { clearAmenities, clearFilteredAmenities } from '../../../redux/actions/amenities';
import { setIsOnDashboard, setToast } from '../../../redux/actions/window';
import AddUnit from './Unit/AddUnit';
import ExportCSVButton from '../../../components/ExportCSVButton';
import GlobalAddButton from '../../../components/GlobalAddButton';
import { useTranslation } from 'react-i18next';
import ImportUnitsCSVButton from '../../../components/ImportUnitsCSVButton';
import { DATE_FORMATS, isManagerRole, isYardiPropertyProvider, SYNC_OPTIONS, SYNC_STATUSES, UserRole } from '../../../views/users/constant';
import {
  AddNewButton,
  TablePageHeader,
  TablePageTitle
} from '../../../components/tables/TableComponents';
import { OptionsContainer } from '../../manage-users/ManageUserComponents';
import { FaArrowLeft } from 'react-icons/fa';
import styled from 'styled-components';
import { openModal } from '../../../helper/modals';
import { StyledTabLabel, Tab, TabList } from '../../../containers/TheHeaderDropdownMssg';
import { StyledCard, StyledCardBody } from '../../../components/Cards';
import { getOrgConfig, syncRequest } from '../../../redux/actions/organization';
import { formatSuiteFloorDisplay } from './Suites/suiteFloorDisplay';
import Suites from './Suites/Suites';
import CustomSearchBar from '../../../components/CustomSearchBar';
import {
  resetCSVSuites,
  resetSearchTextSuite,
  setCSVSuites,
  setSearchTextSuite,
  syncYardiSuites
} from '../../../redux/actions/suites';
import { changeOpenedModal } from '../../../redux/actions/headerModal';
import BatteryStatusTable from './BatteryStatus/BatteryStatusTable';
import { shouldHideBatteryLevel } from '../../../utils/lockInfo';
import {useGetConfigs} from '../../../hooks/useGetConfigs';
import { Button, ButtonBody } from '../../../components/ui/Button';
import { requestPending } from '../../../utils/status';
import { SYNC_YARDI_SUITES } from '../../../redux/constants';
import {isEntrataPropertyProvider} from '../../../utils/utils';
import {getUnits} from '../../../redux/actions/unit';
import {Palette} from '../../../components/utils';
import {Flex} from '../../../components/ui/Flex';
import moment from 'moment';
import useSearchHelper from '../../../hooks/useSearchHelper';
import { searchTable, setSearchPagination, setSearchState } from '../../../redux/actions/search';
import { Form, FormControl, FormField, FormItem } from '../../../components/ui/Form';
import { SearchCloseIcon, SearchContainer, SearchIcon } from '../../../components/tables/NewTableComponents';
import { Input } from '../../../components/ui/Input';
import { Separator } from '../../../components/ui/Separator';
import { ButtonBodyVariant } from '../../../components/ui/ButtonVariant';

export const AVAILABLE_TABS = {
  SUITE: 'suite',
  UNITS: 'units',
  AMENITIES: 'amenities',
  BATTERY_STATUS: 'battery_status'
};

const FETCH_YARDI_UNITS_DELAY = 15000;
const FIRST_PAGE = 1;

const UnitAmenities = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const building = useSelector((state) => state.building.building);
  const buildings = useSelector((state) => state.building.buildings);
  const filteredAmenities = useSelector((state) => state.amenities.filteredAmenities);
  const csvSuites = useSelector((state) => state.suites.csvSuites);
  const suitesStatus = useSelector((state) => state.suites.status);
  const searchText = useSelector((state) => state.suites.searchText);
  const searchState = useSelector((state) => state.search);
  const units = useSelector((state) => state.unit.units);
  const roleId = useSelector((state) => state.auth.roleId);
  const { config } = useGetConfigs();
  const { organization } = useSelector((state) => state.Organization);
  const [chosenTab, setChosenTab] = useState(AVAILABLE_TABS.UNITS);
  const [preparedSuitesCSVData, setPreparedSuitesCSVData] = useState([]);
  const [preparedBatteryTableInfo, setPreparedBatteryTableInfo] = useState([]);
  const [activeSuitePage, setSuiteActivePage] = useState(1);
  const [itemsPerSuitePage, setItemsPerSuitePage] = useState(10);
  const [suiteSort, setSuiteSort] = useState('name');
  const [suiteSortOrder, setSuiteSortOrder] = useState('ASC');
  const [isLoading, setIsLoading] = useState(true);
  const [isYardiLoading, setIsYardiLoading] = useState(false);
  const [isSyncEntrataLoading, setIsSyncEntrataLoading] = useState(false);
  const firstRequest = useRef(true);
  const intervalSyncRef = useRef(null);
  const attemptsRef = useRef(0);

  const unitSearchHelper = useSearchHelper({
    search: '',
    building_id: 0,
    category: 0,
    minCreationDate: undefined,
    maxCreationDate: undefined,
    filters: {},
    ordering: { 'u.unit_num': 'ASC' },
    pagination: { page: 1, limit: 10 }
  });

  const unitSearchForm = useForm({ mode: 'onSubmit', defaultValues: { search: '' } });

  // Sometimes building object does not have yardi_id, so we have to check the building in buildings array
  const isYardiBuilding = Boolean(building?.yardi_id || buildings?.find(
    b => b.org_id === building?.org_id && b.id === building?.id
  )?.yardi_id)

  const searchUnits = (overrideValues = {}) => {
    if (!building?.id || !building?.org_id) return;
    const searchOptions = unitSearchHelper.getSearchOptions(overrideValues);
    const body = {
      search: searchOptions.search ?? '',
      building_id: building.id,
      category: searchOptions.category ?? 0,
      minCreationDate: searchOptions.minCreationDate ?? '',
      maxCreationDate: searchOptions.maxCreationDate ?? '',
      filters: searchOptions.filters ?? {},
      ordering: searchOptions.ordering ?? {},
      pagination: searchOptions.pagination ?? { page: 1, limit: 10 }
    };
    dispatch(
      searchTable({
        entity: 'units',
        orgID: building.org_id,
        body,
        success: (res) => {
          dispatch(
            setSearchState({
              currentData: res.data?.data ?? [],
              currentPaginationData: res.data?.pagination ?? {}
            })
          );
          if (!res.data?.data?.length && body.pagination?.page > 1) {
            unitSearchHelper.setPagination('page', 1);
            dispatch(setSearchPagination({ page: 1, limit: body.pagination.limit }));
            searchUnits({ pagination: { page: 1, limit: body.pagination.limit } });
          }
        }
      })
    );
  };

  const getSearchedSuites = () => {
    // Page change triggers the activeSuitePage effect; only fetch here when already on page 1.
    if (activeSuitePage !== FIRST_PAGE) {
      setSuiteActivePage(FIRST_PAGE);
      return;
    }
    getBuildingSuitesByPage(FIRST_PAGE, building?.org_id, building?.id, suiteSort, suiteSortOrder, searchText);
  };

  const emptySearchedSuited = () => {
    if (activeSuitePage !== FIRST_PAGE) {
      setSuiteActivePage(FIRST_PAGE);
      return;
    }
    getBuildingSuitesByPage(FIRST_PAGE, building?.org_id, building?.id, suiteSort, suiteSortOrder, '');
  };

  const openAddSuiteModal = () => {
    dispatch(
      changeOpenedModal({
        modal: 'addSuite'
      })
    );
  };

  const setSearchedText = (text) => {
    dispatch(setSearchTextSuite(text));
  };

  // RE-DO - We should use one func and it switches betwenn fetching units or suites
  const getBuildingUnitsByPage = (page, orgId, buildingId) => {
    if (!page || !orgId || !buildingId) {
      return;
    }

    setIsLoading(true);
    dispatch(
      getUnits({
        id: buildingId,
        page,
        sort: 'floor',
        sortOrder: 'ASC',
        perPage: itemsPerSuitePage,
        success: () => {},
        fail: () => {
          dispatch(setCSVSuites([]));
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Failed to fetch units!'),
              modal: 'errorToast'
            })
          );
        }
      })
    );
  };
  const getBuildingSuitesByPage = (
    page,
    orgId,
    buildingId,
    sortOverride,
    sortOrderOverride,
    searchTextOverride
  ) => {
    if (!page || !orgId || !buildingId) {
      return;
    }

    setIsLoading(true);
    dispatch(
      getBuildingSuites({
        orgId: orgId,
        buildingId: buildingId,
        page: page,
        per_page: itemsPerSuitePage,
        searchText: searchTextOverride !== undefined ? searchTextOverride : searchText,
        sort: sortOverride ?? suiteSort,
        sortOrder: sortOrderOverride ?? suiteSortOrder,
        success: () => {},
        fail: () => {
          dispatch(setCSVSuites([]));
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Failed to fetch suites!'),
              modal: 'errorToast'
            })
          );
        }
      })
    );
  };

  const handleSuiteSortChange = ({ sort, sortOrder }) => {
    setSuiteSort(sort);
    setSuiteSortOrder(sortOrder);

    // Page change triggers the activeSuitePage effect; only fetch here when already on page 1.
    if (activeSuitePage !== FIRST_PAGE) {
      setSuiteActivePage(FIRST_PAGE);
      return;
    }

    if (building?.org_id && building?.id) {
      getBuildingSuitesByPage(FIRST_PAGE, building.org_id, building.id, sort, sortOrder);
    }
  };

  const handleSyncYardiSuites = () => {
    setIsYardiLoading(true);
    dispatch(
      syncYardiSuites({
        orgId: building?.org_id,
        buildingId: building?.id,
        success: () => {
          setTimeout(() => {
            setIsYardiLoading(false);
            getBuildingSuitesByPage(activeSuitePage, building?.org_id, building?.id);
            dispatch(
              setToast({
                toastShow: true,
                toastMessage: t('Units synced successfully!'),
              })
            );
          }, FETCH_YARDI_UNITS_DELAY);
        },
        fail: () => {
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Failed to sync units'),
              modal: 'errorToast'
            })
          );
        }
      })
    )
  }
  
  const startPollingSyncData = (buildingId) => {
    const performPoll = () => {
      attemptsRef.current++;

      dispatch(
        getBuilding({
          id: buildingId,
          success: ({ data }) => {
            getBuildingUnitsByPage(activeSuitePage, building?.org_id, building?.id);

            const isComplete = data?.units_sync_status === SYNC_STATUSES.COMPLETE;

            if (attemptsRef.current === 1 && isComplete) return;
   
            if (isComplete || attemptsRef.current >= 300) {
              if (isComplete) {
                console.log("Sync is complete. Stopping polling.");
                dispatch(
                  setToast({
                    toastShow: true,
                    toastMessage: t('Units synced successfully!'),
                  })
                );
              } else {
                console.warn("Polling timed out. Stopping.");
              }
              setIsSyncEntrataLoading(false);
              clearInterval(intervalSyncRef.current);
            }
          },
          fail: () => {
            console.warn('Polling API call failed. Stopping polling.');
            setIsSyncEntrataLoading(false);
            clearInterval(intervalSyncRef.current);
          }
        })
      );
    };

    attemptsRef.current = 0;
    if (intervalSyncRef.current) {
      setIsSyncEntrataLoading(false);
      clearInterval(intervalSyncRef.current);
    }
    
    performPoll();

    intervalSyncRef.current = setInterval(performPoll, 3000);
  };

  useEffect(() => {
    return () => {
      if (intervalSyncRef?.current) clearInterval(intervalSyncRef.current);
    };
  }, []);

  useEffect(() => {
    if(Boolean(building?.id) && building?.units_sync_status === SYNC_STATUSES.IN_PROGRESS){
      setIsSyncEntrataLoading(true);
      startPollingSyncData(building.id);
    }
  }, []);

  useEffect(() => {
    if (chosenTab !== AVAILABLE_TABS.UNITS || !building?.id || !building?.org_id) return;
    unitSearchHelper.setCustomOption('building_id', () => building.id);
    const defaultOrdering = { 'u.unit_num': 'ASC' };
    unitSearchHelper.setOrdering(defaultOrdering);
    dispatch(setSearchState({ building_id: building.id }));
    searchUnits({ ordering: defaultOrdering });
  }, [chosenTab, building?.id, building?.org_id]);

  const onUnitSearchSubmit = (values) => {
    unitSearchHelper.setCustomOption('search', () => values.search ?? '');
    dispatch(setSearchState({ search: values.search ?? '' }));
    unitSearchHelper.setPagination('page', 1);
    dispatch(setSearchPagination({ page: 1, limit: 10 }));
    searchUnits({
      search: values.search ?? '',
      pagination: { page: 1, limit: 10 }
    });
  };

  const handleSyncEntrataUnits = () => {
    if (!Boolean(building?.org_id) || !Boolean(building?.id)) {
      dispatch(
        setToast({
          toastShow: true,
          toastMessage: t('Please select a building'),
          modal: 'errorToast'
        })
      );
      return;
    }

    setIsSyncEntrataLoading(true);

    dispatch(
      syncRequest({
        body: {
          org_id: building?.org_id,
          building_id: building?.id,
          type_id: SYNC_OPTIONS.UNITS,
        },
        success: () => {
          // Reset sync loading state in the next func
          startPollingSyncData(building.id);
        },
        fail: () => {
          setIsSyncEntrataLoading(false);
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Failed to sync units'),
              modal: 'errorToast'
            })
          );
        }
      })
    )
  }

  useEffect(() => {
    if (activeSuitePage > 0 && config?.suite_enabled) {
      getBuildingSuitesByPage(activeSuitePage, building?.org_id, building?.id);
    }
  }, [activeSuitePage]);

  useEffect(() => {
    const buildingIdFromUrl = history.location.pathname.split('/')[2];
    dispatch(resetSearchTextSuite());
    dispatch(
      getBuilding({
        id: buildingIdFromUrl,
        success: (buildingRes) => {
          dispatch(
            getOrgConfig({
              id: buildingRes?.data?.org_id,
              success: (data) => {
                firstRequest.current = false;
                setChosenTab(
                  buildingRes?.data?.config?.suite_enabled ? AVAILABLE_TABS.SUITE : AVAILABLE_TABS.UNITS
                );
                if (buildingRes?.data?.config?.suite_enabled) {
                  getBuildingSuitesByPage(
                    activeSuitePage,
                    buildingRes?.data?.org_id,
                    buildingRes?.data?.id
                  );
                  dispatch(getOrgBuildingSuites({ buildingId: buildingRes?.data?.id, orgId: buildingRes?.data?.org_id }));
                }
              },
              fail: () => {
                dispatch(
                  setToast({
                    toastShow: true,
                    toastMessage: t('Failed to fetch the org config!'),
                    modal: 'errorToast'
                  })
                );
              }
            })
          );
        },
        fail: () => {
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Failed to fetch the building!'),
              modal: 'errorToast'
            })
          );
        }
      })
    );
  }, [history.location.pathname]);

  useEffect(() => {
    dispatch(setIsOnDashboard(false)); // to hide the global building DD
    return () => {
      dispatch(clearAmenities());
      dispatch(clearFilteredAmenities());
    };
  }, []);

  // Reset csvSuites when the page is loaded
  useEffect(() => {
    dispatch(setCSVSuites([]));
  }, []);

  useEffect(() => {
    if (chosenTab === AVAILABLE_TABS.SUITE) {
      setPreparedSuitesCSVData(
        csvSuites.map((suite) => {
          return {
            name: suite?.name,
            area: suite?.area,
            floor: formatSuiteFloorDisplay(suite?.floor),
            rooms: suite?.rooms,
            battery: suite?.devices
              ?.map((device) => `${device.name} ${device?.battery_level}`)
              .join('; ')
          };
        })
      );
    }
  }, [chosenTab, csvSuites]);

  useEffect(() => {
    dispatch(showGlobalBuildingsDropdown(false));
    return () => {
      dispatch(showGlobalBuildingsDropdown(true));
    };
  }, []);

  const TabButtons = {
    [AVAILABLE_TABS.AMENITIES]:
    (<AddNewButton
      disabled={roleId < UserRole.SUPER_ADMIN && config?.org_allow_edits === false}
      onClick={() => openModal('addAmenityV2')}
    />),
    [AVAILABLE_TABS.SUITE]: 
    (<>
      <CustomSearchBar
        setValue={setSearchedText}
        handleSearch={getSearchedSuites}
        handleGet={emptySearchedSuited}
        // entitySearch={entity}
        showSelect={false}
        initialValue={searchText}
      />
      <AddNewButton
        disabled={roleId < UserRole.SUPER_ADMIN && config?.org_allow_edits === false}
        onClick={openAddSuiteModal}
      />
      {isYardiPropertyProvider(organization) && isYardiBuilding && config?.suite_enabled && roleId === UserRole.SUPER_ADMIN && (
        <StyledSyncButton isPrimary text={t("Sync Yardi Units")} onClick={handleSyncYardiSuites} disabled={isYardiLoading} />
      )}
    </>),
    [AVAILABLE_TABS.UNITS]: (
      <>
        <Form {...unitSearchForm}>
          <form onSubmit={unitSearchForm.handleSubmit(onUnitSearchSubmit)} style={{ flex: 1 }}>
            <SearchContainer>
              <FormField
                control={unitSearchForm.control}
                name="search"
                render={({ field }) => (
                  <FormItem>
                    <FormControl style={{ position: 'relative' }}>
                      <SearchIcon size={18} />
                      <Input
                        placeholder={t('Search')}
                        style={{ paddingLeft: '40px', paddingRight: '40px' }}
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          unitSearchHelper.setCustomOption('search', () => e.target.value);
                          dispatch(setSearchState({ search: e.target.value }));
                          if (e.target.value.length === 0) {
                            searchUnits({ search: '' });
                          }
                        }}
                      />
                      <SearchCloseIcon
                        size={18}
                        onClick={() => {
                          unitSearchForm.setValue(field.name, '');
                          unitSearchHelper.setCustomOption('search', () => '');
                          dispatch(setSearchState({ search: '' }));
                          searchUnits({ search: '' });
                        }}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              <Separator color={Palette.BLACK_20} />
              <ButtonBodyVariant type="submit">{t('Search')}</ButtonBodyVariant>
            </SearchContainer>
          </form>
        </Form>
        {(roleId === UserRole.SUPER_ADMIN || config?.org_allow_edits) && 
          <>
            <GlobalAddButton text="Add" modalName="addUnit" />
            {isEntrataPropertyProvider(organization) && isManagerRole(roleId) && (
              <StyledSyncButton isPrimary text={t("Sync Units")} onClick={handleSyncEntrataUnits} disabled={isSyncEntrataLoading} />
            )}
          </>
        }
      </>
    ),
    // [AVAILABLE_TABS.UNITS]: (roleId === UserRole.SUPER_ADMIN || config?.org_allow_edits) ?
    // (
    //   <>
    //     <GlobalAddButton text="Add" modalName="addUnit" />
    //     {isEntrataPropertyProvider(organization) && isManagerRole(roleId) && (
    //       <StyledSyncButton isPrimary text={t("Sync Units")} onClick={handleSyncEntrataUnits} disabled={isSyncEntrataLoading} />
    //     )}
    //   </>
    // ) : null,
  };

  return (
    <div>
      <StyledCard>
        <StyledCardBody>
          <TablePageHeader>
            <StyledLinkHeader>{building && <>{building.name}</>}</StyledLinkHeader>

            <OptionsContainer>
              {
                TabButtons[chosenTab]
              }
              { chosenTab !== AVAILABLE_TABS.AMENITIES &&
                chosenTab !== AVAILABLE_TABS.BATTERY_STATUS &&
                (roleId === UserRole.SUPER_ADMIN || (roleId === UserRole.ADMIN &&
                config?.org_allow_edits)) && <ImportUnitsCSVButton chosenTab={chosenTab} />}
              <ExportCSVButton
                Data={
                  chosenTab === AVAILABLE_TABS.BATTERY_STATUS
                    ? preparedBatteryTableInfo
                    : chosenTab === AVAILABLE_TABS.AMENITIES
                    ? filteredAmenities
                    : chosenTab === AVAILABLE_TABS.SUITE
                    ? preparedSuitesCSVData
                    : searchState.currentData
                }
              />
            </OptionsContainer>
          </TablePageHeader>

          <Flex justify="flex-end">
            {isEntrataPropertyProvider(organization) && Boolean(building?.id) && (
              <LastSyncText>
                {t('Last sync')}:&nbsp;
                {building?.units_sync_status === SYNC_STATUSES.IN_PROGRESS
                  ? t(building?.units_sync_status)
                  : Boolean(building?.last_units_sync)
                    ? moment(building.last_units_sync).format(DATE_FORMATS.YYYY_MM_DD_hh_mm_A)
                    : t('Never')}
              </LastSyncText>
            )}
          </Flex>

          <TabList>
            {config?.suite_enabled && (
              <Tab
                isActive={chosenTab === AVAILABLE_TABS.SUITE}
                onClick={() => setChosenTab(AVAILABLE_TABS.SUITE)}>
                <StyledTabLabel>{t('Units')}</StyledTabLabel>
              </Tab>
            )}
            <Tab
              isActive={chosenTab === AVAILABLE_TABS.UNITS}
              onClick={() => setChosenTab(AVAILABLE_TABS.UNITS)}>
              <StyledTabLabel>
                {t(config?.suite_enabled ? 'Rooms' : 'Units')}
              </StyledTabLabel>
            </Tab>
            <Tab
              isActive={chosenTab === AVAILABLE_TABS.AMENITIES}
              onClick={() => setChosenTab(AVAILABLE_TABS.AMENITIES)}>
              <StyledTabLabel>{t('Amenities')}</StyledTabLabel>
            </Tab>
            {!shouldHideBatteryLevel(building) && (
              <Tab
                isActive={chosenTab === AVAILABLE_TABS.BATTERY_STATUS}
                onClick={() => setChosenTab(AVAILABLE_TABS.BATTERY_STATUS)}>
                <StyledTabLabel>{t('Battery Status')}</StyledTabLabel>
              </Tab>
            )}
          </TabList>

          {chosenTab === AVAILABLE_TABS.SUITE ? (
            <Suites
              csvSuites={csvSuites}
              firstRequest={firstRequest}
              activePage={activeSuitePage}
              setActivePage={setSuiteActivePage}
              itemsPerPage={itemsPerSuitePage}
              setItemsPerPage={setItemsPerSuitePage}
              isLoading={isLoading || suitesStatus === requestPending(SYNC_YARDI_SUITES) || isYardiLoading}
              setIsLoading={setIsLoading}
              suiteSort={suiteSort}
              suiteSortOrder={suiteSortOrder}
              onSortChange={handleSuiteSortChange}
            />
          ) : chosenTab === AVAILABLE_TABS.AMENITIES ? (
            <Amenities />
          ) : chosenTab === AVAILABLE_TABS.BATTERY_STATUS ? (
            <BatteryStatusTable setPreparedBatteryTableInfo={setPreparedBatteryTableInfo} />
          ) : (
            <Unit
              useSearchMode={true}
              onPageChange={(page) => {
                unitSearchHelper.setPagination('page', page);
                dispatch(setSearchPagination({ page, limit: 10 }));
                searchUnits({ pagination: { page, limit: 10 } });
              }}
              onRefetch={() => searchUnits()}
              onSearchSortChange={(nextOrdering) => {
                unitSearchHelper.setOrdering(nextOrdering);
                unitSearchHelper.setPagination('page', 1);
                dispatch(setSearchPagination({ page: 1, limit: 10 }));
                searchUnits({ ordering: nextOrdering, pagination: { page: 1, limit: 10 } });
              }}
            />
          )}

          <AddUnit />
        </StyledCardBody>
      </StyledCard>
    </div>
  );
};

const StyledLinkHeader = styled(TablePageTitle)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledSyncButton = styled(Button)`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  height: 46px;
  max-width: 180px;
`;

const LastSyncText = styled.p`
  font-size: 14px;
  color: ${Palette.BLACK_50};
  margin: 0;
`;

export default UnitAmenities;
